var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('a',{staticClass:"btn",class:[
        'btn-' + _vm.background,
        'btn-' + _vm.size,
        { compliance: _vm.$store.state.settings.norway_compliance }
    ],attrs:{"href":_vm.url,"target":_vm.target},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n    "),(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_vm._v(" "),(_vm.$store.state.settings.norway_compliance)?_c('div',{staticClass:"compliance-text"},[_vm._v("\n        Annonslenke\n    ")]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }